"use client"

import { ApplicationEnvironmentMolecule } from "@/app/env/store"
import {
  type CoinflowEnvs,
  CoinflowPurchaseProtection,
} from "@coinflowlabs/react"
import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"

/**
 * Mounts Coinflow's chargeback-protection (nSure) script when a merchant
 * ID is configured. The checkout widget reads the resulting nSure device id
 * itself. Renders nothing when Coinflow is not configured.
 */
export const CoinflowPurchaseProtectionMount = reatomComponent(() => {
  const env = useMolecule(ApplicationEnvironmentMolecule)
  if (!env.coinflowMerchantId) return null
  const coinflowEnv: CoinflowEnvs =
    env.coinflowEnv === "prod" ? "prod" : "sandbox"
  return (
    <CoinflowPurchaseProtection
      coinflowEnv={coinflowEnv}
      merchantId={env.coinflowMerchantId}
    />
  )
}, "CoinflowPurchaseProtectionMount")
